"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateShipName = exports.validateUsername = void 0;
/**
 * validates usernames, which can contain a-z, A-Z,0-9, and _.
 * They must be greater than 4 characters and less than 25.
 */
function validateUsername(username) {
    if (!username) {
        return null;
    }
    if (username.length < 4 || username.length > 25) {
        return "LENGTH";
    }
    const regex = /^[a-zA-Z0-9_]+$/;
    if (!regex.test(username)) {
        return "INVALID";
    }
    return "AVAILABLE";
}
exports.validateUsername = validateUsername;
// should match "~cvccvc-cvccvc" and ~finnem-pilbes but not finnem-pilbes
const UrbitPlanetRegex = /~[a-z]{6}-[a-z]{6}/g;
function validateShipName(shipName) {
    const matches = shipName.match(UrbitPlanetRegex);
    return !!(matches && matches[0] === shipName);
}
exports.validateShipName = validateShipName;
//# sourceMappingURL=validateUsername.js.map